/* eslint-disable react/no-danger */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
// import atob from 'atob';
import {
  Grid,
  Container,
  Segment,
  Header,
  Dropdown,
  Message,
  Form,
  TextArea,
  Button,
  Input,
  Divider,
  Checkbox,
  Image,
  Icon,
  Label,
} from 'semantic-ui-react';
import moment from 'moment';
import FileUploader from 'react-firebase-file-uploader';

import { base, cloudFunctionsURL, firebaseAuth, firebaseStorage, REGEX_PATTERNS } from '../../../config/constants';
import {
  AlertBox, ConfirmBox,
  setAlertMsg,
} from '../../../components/Modals';
import { NewsItem } from '../../../components/News/index';
import { MapSearchAndSelect, MapListView } from '../../../components/Maps/index';


export default class Send extends Component {
  static propTypes = {
    history: PropTypes.object,
    habilitations: PropTypes.object,
    availableThemes: PropTypes.array,
    themeType: PropTypes.string,
  }

  static defaultProps = {
    habilitations: { uid: null },
    history: null,
    availableThemes: [],
    themeType: 'themes',
  }

  constructor(props) {
    super(props);
    this.state = {
      draftedMessage: {
        titre: '',
        message: '',
        lien: {
          url: '',
        },
        // targets: {},
      },
      formErrors: {
        title: false,
        message: false,
        link: false,
        image: false,
        location: false,
        targets: false,
      },
      listenersLoading: true,
      verified: false,
      sending: false,
      isUploading: false,
    };
    this.fields = {
      titre: null,
      message: null,
    };
  }

  componentDidMount() {
    this.selectedBinding = base.syncState(`administrateurs/${this.props.habilitations.uid}/draft/${this.props.themeType}`, {
      context: this,
      state: 'draftedMessage',
      then: () => {
        // TODO if state, initialize
        if (this.state.draftedMessage.sending) {
          this.setState({
            ...setAlertMsg(
              null,
              'Envoi en cours',
              'Une notification est en cours d\'envoi.<br />' +
              'Vous ne pourrez pas envoyer d\'autre notification de ce type tant que le traitement de celle-ci' +
              ' n\'est pas terminé, ce qui peut prendre quelques dizaines de secondes.',
              'info',
            ),
            sending: false,
            listenersLoading: false,
          });
        } else {
          this.setState({ listenersLoading: false });
        }
        this.getUploadedImageMetadata();
      },
    });
  }

  componentWillUnmount() {
    this.safeSetState = () => null;
  }

  getLinkPlaceHolderFromType = () => {
    if (!this.state.draftedMessage || !this.state.draftedMessage.lien) {
      return '';
    }

    switch (this.state.draftedMessage.lien.type) {
      case 'phone':
        return 'EXEMPLE: 02 41 95 30 13';
      case 'mail':
        return 'EXEMPLE: cob.commune+liste@gendarmerie.interieur.gouv.fr';
      case 'twitter':
        return 'EXEMPLE: https://twitter.com/Gendarmerie/status/981438449931751424';
      case 'facebook':
        return 'EXEMPLE: https://www.facebook.com/GGD49/posts/2011830652399933';
      case 'web':
        return 'EXEMPLE: https://www.exemple.fr/page/exemple';
      default:
        return 'Lien';
    }
  }

  getLinkLabelFromType = () => {
    if (!this.state.draftedMessage || !this.state.draftedMessage.lien) {
      return '';
    }

    switch (this.state.draftedMessage.lien.type) {
      case 'phone':
        return 'Numéro de téléphone';
      case 'mail':
        return 'Adresse email';
      case 'twitter':
        return 'Adresse URL du Tweet';
      case 'facebook':
        return 'Adresse URL de la publication Facebook';
      case 'web':
        return 'Adresse URL';
      default:
        return 'Lien';
    }
  }

  getUploadedImageMetadata = () => {
    if (this.state.draftedMessage.image) {
      return firebaseStorage.ref(`drafts/${this.props.habilitations.uid}/${this.props.themeType}.${this.state.draftedMessage.image.ext}`)
        .getMetadata().then((imageMetadata) => {
          // console.log(imageMetadata);
          if (!imageMetadata.contentType || !imageMetadata.contentType.startsWith('image/')) {
            this.safeSetState({ draftedMessage: { ...this.state.draftedMessage, image: null } });
          }
          return this.safeSetState({ imageMetadata });
        }).catch((error) => {
          if (error.code === 'storage/object-not-found') {
            this.safeSetState({ draftedMessage: { ...this.state.draftedMessage, image: null } });
          }
        });
    }
    return null;
  }

  getThemeTypeLabel = (cap = false, plural = false) => {
    switch (this.props.themeType) {
      case 'themes':
        return `${(cap ? 'P' : 'p')}rofession${(plural ? 's' : '')}`;
      case 'citizenly':
        return `${(cap ? 'C' : 'c')}ommune${(plural ? 's' : '')}`;
      case 'elected':
        return `${(cap ? 'C' : 'c')}irconscription${(plural ? 's' : '')}`;
      default:
        return '[THEME]';
    }
  }

  getPreviewDisabledStatus = () => {
    const { draftedMessage } = this.state;
    if (!draftedMessage.type || (!draftedMessage.titre && !draftedMessage.message)) {
      return true;
    }
    return false;
  };

  setImagePosition = (e, { value }) => {
    if (!this.state.draftedMessage.image) {
      return null;
    }
    return this.setState({
      draftedMessage: {
        ...this.state.draftedMessage,
        image: {
          ...this.state.draftedMessage.image,
          position: value,
        },
      },
      verified: false,
    });
  }

  safeSetState = state => this.setState(state);

  linkUrlStateToInputVal = (type, value) => {
    switch (type) {
      case 'phone':
        return value.substr(4);
      case 'mail':
        return value.substr(7);
      default:
        return value;
    }
  }

  linkUrlInputValToState = (type, value) => {
    switch (type) {
      case 'phone':
        return `tel:${value}`;
      case 'mail':
        return `mailto:${value}`;
      default:
        return value;
    }
  }

  handleUploadStart = () => this.setState({ isUploading: true });

  handleProgress = () => null;

  handleUploadError = (error) => {
    this.setState({
      isUploading: false,
      verified: false,
    });
    console.error(error);
  }

  handleUploadSuccess = (filename) => {
    this.setState({
      isUploading: false,
      draftedMessage: {
        ...this.state.draftedMessage,
        image: {
          ext: _.last(filename.split('.')),
          position: 'before',
        },
      },
      verified: false,
    });
    setTimeout(() => this.getUploadedImageMetadata(), 1000);
    // console.log(filename);
    // firebase.storage().ref('images').child(filename).getDownloadURL().then(url => this.setState({avatarURL: url}));
  };

  handleMakeVerifications = () => {
    const { draftedMessage } = this.state;
    if (!draftedMessage) {
      return false;
    }


    const formErrors = {
      titre: false,
      type: false,
      message: false,
      link: false,
      image: false,
      location: false,
      targets: false,
    };

    if (draftedMessage.lien && draftedMessage.lien.type !== 'none') {
      formErrors.link = this.matchLinkToItsType(draftedMessage.lien.url, draftedMessage.lien.type, true);
    }

    if (!draftedMessage.type) {
      formErrors.type = 'Vous devez sélectionner un type de notification.';
    }

    if (!draftedMessage.titre || draftedMessage.titre.length < 3) {
      formErrors.titre = 'Le titre de la notification doit faire au moins 3 caractères';
    }

    if (!draftedMessage.message || draftedMessage.message.length < 10) {
      formErrors.message = 'Le corps de la notification doit faire au moins 10 caractères';
    }

    if (!draftedMessage.targets) {
      formErrors.targets = `Aucune ${this.getThemeTypeLabel()} sélectionnée`;
    }


    return this.setState({
      verified: !_.some(formErrors),
      formErrors,
    });
  }

  handleSendNotification = () => {
    if (this.state.sending || !this.state.verified || _.some(this.state.formErrors)) {
      return null;
    }
    this.setState({ sending: true });
    return firebaseAuth().currentUser.getIdToken(/* forceRefresh */ false)
      .then(idToken => fetch(`${cloudFunctionsURL}/sendNotification/?type=${this.props.themeType}`, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${idToken}`,
        },
      }).then(resp => resp.json()).then((data) => {
        // setAlertMsg()
        if (data.error) {
          this.setState({
            ...setAlertMsg(null, 'Erreur lors de l\'envoi de la notification', data.msg, 'error'),
            sending: false,
          });
        } else {
          this.setState({
            ...setAlertMsg(
              null,
              'Notification en cours d\'envoi',
              'La notification a bien été enregistrée, elle est désormais en cours d\'envoi vers les différents' +
              ' destinataires.<br' +
              ' />' +
              'Vous pouvez désormais quitter cette page ou envoyer un autre message.',
              'success',
            ),
            sending: false,
            verified: false,
          });
        }
      }).catch(error => this.setState({
        ...setAlertMsg(error.code || null, 'Erreur lors de l\'envoi de la notification', 'Erreur technique', 'error'),
        sending: false,
      })))
      .catch(error => this.setState({
        ...setAlertMsg(error.code || null, 'Erreur lors de l\'envoi de la notification', error.toString(), 'error'),
        sending: false,
      }));
  }

  matchLinkToItsType = (url, type, resAsString) => {
    const urlContent = this.linkUrlStateToInputVal(type, url);
    switch (type) {
      case 'phone':
        return REGEX_PATTERNS.phone.test(urlContent) ? false : (!resAsString || 'Numéro de téléphone invalide');
      case 'mail':
        return REGEX_PATTERNS.email.test(urlContent) ? false : (!resAsString || 'Adresse email invalide');
      case 'twitter':
        return urlContent.startsWith('https://twitter.com/')
          ? false : (!resAsString || 'Le lien Twitter doit commencer par <strong>https://twitter.com/</strong>');
      case 'facebook':
        return urlContent.startsWith('https://www.facebook.com/')
          ? false : (!resAsString || 'Le lien Facebook doit commencer par <strong>https://www.facebook.com/</strong>');
      case 'web':
        return (urlContent.startsWith('https://') || urlContent.startsWith('http://'))
          ? false : (!resAsString || 'Le lien web doit commencer par <strong>https://</strong>' +
            ' ou <strong>https://</strong>');
      default:
        return 'Lien';
    }
  }


  render() {
    // console.log(this.state.draftedMessage);
    const {
      image, lien, lieu, message, titre, type, latitude, longitude,
    } = this.state.draftedMessage;
    const { formErrors } = this.state;

    const linkOptions = [
      {
        key: 'none', text: 'Aucun', value: 'none', icon: 'dont',
      },
      {
        key: 'web', text: 'Lien web', value: 'web', icon: 'globe',
      },
      {
        key: 'facebook', text: 'Facebook', value: 'facebook', icon: 'facebook',
      },
      {
        key: 'twitter', text: 'Twitter', value: 'twitter', icon: 'twitter',
      },
      {
        key: 'mail', text: 'Adresse email', value: 'mail', icon: 'at',
      },
      {
        key: 'phone', text: 'Téléphone', value: 'phone', icon: 'phone',
      },
    ];

    const targets = this.state.draftedMessage.targets ? Object.keys(this.state.draftedMessage.targets) : [];
    const themesAvailableOptions = _.map(this.props.availableThemes, i => ({ key: i.key, value: i.key, text: i.nom }));
    const nulledTargets = _.reduce(this.props.availableThemes, (r, i) => {
      // eslint-disable-next-line no-param-reassign
      r[i.key] = null;
      return r;
    }, {});

    return (
      <Container>
        <Segment
          basic
          loading={
            this.state.listenersLoading
            || !this.state.draftedMessage
            || this.state.draftedMessage.sending
            || this.state.sending
          }
        >
          <Grid columns={2}>
            <Grid.Column width={9}>
              <Grid.Row>
                <Segment
                  // attached
                  padded
                  basic
                >
                  <Message info size="small">
                    <Message.Header>Procédure de rédaction d'une notification</Message.Header>
                    <Message.List>
                      <Message.Item>
                        Utilisez les champs ci-dessous pour rédiger et paramétrer la notification.<br />
                        Le <strong>contenu principal</strong> est <strong>obligatoire</strong>, le reste est facultatif.
                      </Message.Item>
                      <Message.Item>
                        L'aperçu du rendu final est visible à droite et se met à jour instantanément.<br />
                        Le nom de l'émetteur de la notification n'apparaîtra pas dans l'application mobile.
                      </Message.Item>
                      <Message.Item>
                        Une fois la notification rédigée, suivez la <strong>procédure de transmission</strong> affichée
                        sous l'aperçu.
                      </Message.Item>
                    </Message.List>
                  </Message>
                  <Form warning error={_.some(formErrors)}>
                    <Divider horizontal>Contenu principal</Divider>
                    <Segment>
                      <Form.Field error={!!formErrors.type}>
                        <label htmlFor="notificationType">
                          Type de notification
                          <Button.Group widths={2} compact id="notificationType">
                            <Button
                              icon="info circle"
                              content="Information"
                              labelPosition="left"
                              onClick={() => this.setState({
                                verified: false,
                                formErrors: { ...formErrors, type: false },
                                draftedMessage: {
                                  ...this.state.draftedMessage,
                                  type: 'Information',
                                },
                              })}
                              basic={type !== 'Information'}
                              color={type === 'Information' ? 'blue' : 'grey'}
                            />
                            <Button
                              icon="exclamation triangle"
                              content="Alerte"
                              labelPosition="right"
                              onClick={() => this.setState({
                                verified: false,
                                formErrors: { ...formErrors, type: false },
                                draftedMessage: {
                                  ...this.state.draftedMessage,
                                  type: 'Alerte',
                                },
                              })}
                              basic={type !== 'Alerte'}
                              color={type === 'Alerte' ? 'red' : 'grey'}
                            />
                          </Button.Group>
                        </label>
                      </Form.Field>
                      <Form.Field error={!!formErrors.titre}>
                        <label htmlFor="notificationTitle">
                          Titre de la notification
                          <Input
                            id="notificationTitle"
                            placeholder="Titre de la notification"
                            onChange={(e, { value }) => {
                              this.fields.titre = value;
                              this.setState({
                                verified: false,
                                formErrors: { ...formErrors, titre: false },
                                draftedMessage: { ...this.state.draftedMessage, titre: value },
                              });
                            }}
                            value={titre || ''}
                          />
                        </label>
                      </Form.Field>

                      <Form.Field error={!!formErrors.message}>
                        <label htmlFor="notifBody">
                          Corps de la notification
                          <TextArea
                            // eslint-disable-next-line quotes
                            placeholder="Corps de la notification"
                            id="notifBody"
                            style={{ minHeight: 100 }}
                            autoHeight
                            onChange={(e, { value }) => {
                              this.fields.message = value;
                              this.setState({
                                verified: false,
                                formErrors: { ...formErrors, message: false },
                                draftedMessage: { ...this.state.draftedMessage, message: value },
                              });
                            }}
                            value={message}
                          />
                        </label>
                      </Form.Field>
                    </Segment>
                    <Divider horizontal>Contenu additionnel</Divider>
                    <Segment>
                      <Form.Field>
                        <label htmlFor="typeLien">
                          Type de contenu (facultatif)
                          <Dropdown
                            labeled
                            placeholder="Sélectionner un type de contenu"
                            options={linkOptions}
                            fluid
                            selection
                            id="typeLien"
                            defaultValue={
                              lien && lien.type
                                ? lien.type : null
                            }
                            value={lien ? lien.type : null}
                            onChange={
                              (e, { value }) => {
                                this.setState({
                                  draftedMessage: {
                                    verified: false,
                                    ...this.state.draftedMessage,
                                    lien: value === 'none' ? null : {
                                      // ...lien,
                                      type: value,
                                      url: lien && this.state.draftedMessage.url
                                        ? lien.url : '',
                                    },
                                  },
                                });
                              }
                            }
                          />
                        </label>
                      </Form.Field>


                      {lien && lien.type !== 'none' ?
                        (
                          <Form.Field error={!!formErrors.link}>
                            <label htmlFor="contenuLien">
                              {this.getLinkLabelFromType()}
                              <Input
                                id="contenuLien"
                                placeholder={this.getLinkPlaceHolderFromType()}
                                value={this.linkUrlStateToInputVal(lien.type, lien.url) || ''}
                                onChange={
                                  (e, { value }) => {
                                    this.setState({
                                      verified: false,
                                      formErrors: { ...formErrors, link: false },
                                      draftedMessage: {
                                        ...this.state.draftedMessage,
                                        lien: {
                                          ...lien,
                                          url: this.linkUrlInputValToState(lien.type, value),
                                        },
                                      },
                                    });
                                  }
                                }
                              />
                            </label>
                          </Form.Field>
                        ) : null
                      }
                    </Segment>
                    <Divider horizontal>Image</Divider>
                    {image ?
                      (
                        <Segment padded>
                          <Grid columns={3} verticalAlign="middle">
                            <Grid.Column>
                              <Grid.Row textAlign="center">
                                {!this.state.isUploading && image.preview && (
                                  <Image
                                    centered
                                    wrapped
                                    label={
                                      this.state.imageMetadata ? (
                                        <Label
                                          // attached="bottom left"
                                          floating
                                          basic={
                                            !this.state.imageMetadata.size || this.state.imageMetadata.size <= 256000
                                          }
                                          color={
                                            this.state.imageMetadata.size && this.state.imageMetadata.size > 256000
                                              ? 'red' : 'blue'
                                          }
                                          content={`${(Math.round(this.state.imageMetadata.size / 1024)).toString()} Ko`}
                                        />
                                      ) : null
                                    }
                                    src={image.preview}
                                  />
                                )}
                                {!this.state.isUploading && !image.preview && (
                                  <Label basic color="yellow">Analyse en cours<br />Veuillez patienter.</Label>
                                )}


                              </Grid.Row>
                            </Grid.Column>
                            <Grid.Column>
                              <Form.Field>
                                <Checkbox
                                  radio
                                  label="Avant le texte"
                                  name="checkboxRadioGroup"
                                  value="before"
                                  checked={image
                                  && image.position === 'before'}
                                  onChange={this.setImagePosition}
                                />
                              </Form.Field>
                              <Form.Field>
                                <Checkbox
                                  radio
                                  label="Après le texte"
                                  name="checkboxRadioGroup"
                                  value="after"
                                  checked={image
                                  && image.position === 'after'}
                                  onChange={this.setImagePosition}
                                />
                              </Form.Field>
                            </Grid.Column>
                            <Grid.Column>
                              <Button
                                animated="fade"
                                onClick={() => this.safeSetState({
                                  draftedMessage: {
                                    ...this.state.draftedMessage,
                                    image: null,
                                  },
                                  verified: false,
                                })}
                              >
                                <Button.Content visible>
                                  Supprimer l'image
                                </Button.Content>
                                <Button.Content hidden>
                                  <Icon name="delete" />
                                </Button.Content>
                              </Button>
                            </Grid.Column>
                          </Grid>
                        </Segment>
                      ) : (
                        <Segment textAlign="center" loading={this.state.isUploading}>
                          {this.state.isUploading &&
                          <p>Chargement de l'image en cours...</p>
                          }
                          <label
                            htmlFor="uploader"
                          >
                            Aucune image sélectionnée.<br />
                            Vous pouvez ajouter une image en sélectionnant un fichier :
                            <br /><br />
                            <FileUploader
                              accept="image/*"
                              storageRef={firebaseStorage.ref(`drafts/${this.props.habilitations.uid}`)}
                              filename={this.props.themeType}
                              onUploadStart={this.handleUploadStart}
                              onUploadError={this.handleUploadError}
                              onUploadSuccess={this.handleUploadSuccess}
                              onProgress={this.handleProgress}
                            />
                          </label>
                        </Segment>
                      )
                    }
                    {
                      image && this.state.imageMetadata
                      && this.state.imageMetadata.size && this.state.imageMetadata.size > 260000
                      && (
                        <Message
                          warning
                          size="small"
                        >
                          <Message.Header>Image très volumineuse</Message.Header>
                          <Message.Content>
                            <p>
                              Attention, l'image sélectionnée mesure
                              <strong> {(Math.round(this.state.imageMetadata.size / 1024)).toString()}&nbsp;Ko.</strong>
                              <br />
                              Il est <strong>fortement recommandé</strong> d'utiliser des images dont la
                              <strong> taille est inférieure à 250&nbsp;Ko</strong>.
                            </p>
                          </Message.Content>
                        </Message>
                      )
                    }


                    <Divider horizontal>Géolocalisation</Divider>
                    <Segment>
                      {(latitude || longitude) ? (
                        <Grid columns={1} verticalAlign="middle">
                          <Grid.Column>
                            <Grid.Row>
                              <p>
                                <strong>Longitude</strong> : <em>{longitude}</em><br />
                                <strong>Latitude</strong> : <em>{latitude}</em><br />
                                <strong>Lieu</strong> : <em>{lieu}</em>
                              </p>
                            </Grid.Row>
                            <Grid.Row textAlign="center">
                              <Button
                                fluid
                                animated="fade"
                                onClick={() => this.safeSetState({
                                  draftedMessage: {
                                    ...this.state.draftedMessage,
                                    latitude: null,
                                    longitude: null,
                                  },
                                  verified: false,
                                })}
                              >
                                <Button.Content visible>
                                  Supprimer/modifier la géolocalisation
                                </Button.Content>
                                <Button.Content hidden>
                                  <Icon name="delete" />
                                </Button.Content>
                              </Button>
                            </Grid.Row>
                          </Grid.Column>
                        </Grid>
                      ) : (
                        <div>
                          <Message size="small">
                            <Message.Header>Procédure de géolocalisation de l'information</Message.Header>
                            <p>
                              <strong>1)</strong> Effectuez une <strong>recherche textuelle</strong> du lieu souhaité
                              <br />
                              <strong>2) </strong>
                              Si nécessaire, utilisez le cliquer-glisser pour <strong>ajuster la position</strong> du
                              pointeur sur la carte.<br />
                              <strong>3)</strong> Cliquez sur "<strong>Valider cette géolocalisation</strong>"
                            </p>
                          </Message>
                          <MapSearchAndSelect
                            height={300}
                            selectPosition={(lat, lng, name) => this.safeSetState({
                              draftedMessage: {
                                ...this.state.draftedMessage,
                                latitude: lat,
                                longitude: lng,
                                lieu: name,
                              },
                            })}
                          />
                        </div>
                      )}
                    </Segment>

                  </Form>
                </Segment>
              </Grid.Row>
            </Grid.Column>
            <Grid.Column width={7}>
              <Grid.Row>
                <Segment basic textAlign="center" disabled={this.getPreviewDisabledStatus()}>
                  <Header content="APERÇU" sub />
                  <NewsItem
                    newsItemObject={{
                      ...this.state.draftedMessage,
                      by: this.props.habilitations.email,
                      date: moment().format('DD/MM/YY HH:mm'),
                    }}
                    forcedFileRef={
                      image
                        ? `drafts/${this.props.habilitations.uid}/${this.props.themeType}.${image.ext}`
                        : ''
                    }
                    themeType="fake"
                    themeId="fake"
                  />
                  {latitude && longitude && (
                    <MapListView
                      newsItemsObjects={
                        (latitude && longitude) ? [{ ...this.state.draftedMessage, key: 'uniq' }] : []
                      }
                      height={200}
                    />
                  )}
                </Segment>
                <Divider horizontal>Transmission</Divider>
                <Message attached info size="small">
                  <Message.Header>Procédure de transmission</Message.Header>
                  <Message.List>
                    <Message.Item>
                      <strong>Sélectionnez les {this.getThemeTypeLabel(false, true)}</strong> qui doivent recevoir cette
                      notification.
                    </Message.Item>
                    <Message.Item>
                      Cliquez sur le bouton <strong>Vérifier</strong> et corrigez les éventuelles erreurs.
                    </Message.Item>
                    <Message.Item>
                      Si aucune erreur n'apparaît, cliquez sur "<strong>Envoyer la notification</strong>".
                    </Message.Item>
                  </Message.List>
                </Message>
                <Segment attached>
                  <Form error={_.some(formErrors)}>
                    <Form.Field error={!!formErrors.targets}>
                      <label htmlFor="targetSelection">
                        {this.getThemeTypeLabel(true, true)} destinataires
                        <Dropdown
                          id="targetSelection"
                          placeholder={`Sélectionner une ${this.getThemeTypeLabel()}`}
                          fluid
                          multiple
                          search
                          selection
                          value={targets.length > 0 ? targets : []}
                          onChange={
                            (e, { value }) => {
                              const newVal = _.reduce(value, (r, v) => {
                                // eslint-disable-next-line no-param-reassign
                                r[v] = true;
                                return r;
                              }, {});
                              const newValForFirebase = _.merge(nulledTargets, newVal);
                              this.setState({
                                verified: false,
                                formErrors: { ...formErrors, targets: false },
                                draftedMessage: {
                                  ...this.state.draftedMessage,
                                  targets: newValForFirebase,
                                },
                              });
                            }
                          }
                          options={themesAvailableOptions}
                        />
                      </label>
                    </Form.Field>
                    <Form.Group>
                      <Form.Field>
                        <Button
                          content="Vérifier"
                          icon="search"
                          labelPosition="left"
                          color="blue"
                          disabled={this.state.verified
                          || this.state.isUploading
                          || (image && !image.preview)
                          }
                          onClick={this.handleMakeVerifications}
                        />
                      </Form.Field>
                      <Form.Field>
                        <Button
                          content="Envoyer la notification"
                          icon="send"
                          labelPosition="right"
                          color="green"
                          loading={this.state.sending}
                          disabled={!this.state.verified}
                          onClick={this.handleSendNotification}
                        />
                      </Form.Field>
                    </Form.Group>
                    <Message
                      error
                    >
                      <Message.Header content="Des erreurs empêchent l'envoi de cette notification" />
                      <Message.List>
                        {_.map(formErrors, (e, k) => (e ? (
                          <Message.Item key={k} content={<span dangerouslySetInnerHTML={{ __html: e }} />} />) : null))}
                      </Message.List>
                    </Message>
                  </Form>
                </Segment>
              </Grid.Row>
            </Grid.Column>
          </Grid>
        </Segment>
        <AlertBox
          propagateClosure={() => this.setState({ alert: { open: false } })}
          {...this.state.alert}
        />
        <ConfirmBox
          propagateClosure={() => this.setState({ confirm: { open: false } })}
          {...this.state.confirm}
        />
      </Container>
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/protected/_common/Send.js